import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-product-features',
  templateUrl: './product-features.component.html',
  styleUrls: ['./product-features.component.scss']
})

export class ProductFeaturesComponent implements OnInit, AfterViewInit {

  bottomColorCodes: any[] = ['var(--brand-primary, #1f4edd)', 'var(--brand-secondary, #24b9aa)'];

  features: any[] = [
    {
      image: '../../../assets/prod-feature-ai-generation.svg',
      title: 'AI-Powered Question Generator',
      intro: 'Create assessments in minutes - not weeks. Evaltrix uses advanced AI to auto‑generate fresh, relevant questions based on the skills required for each role.',
      groups: [
        { label: 'Highlights:', items: ['Unlimited AI-generated questions', 'Supports technical & non-technical roles', 'Real‑world scenario questions', 'Zero manual writing needed'] }
      ],
      why: 'Save time, remove guesswork, and evaluate candidates on the skills that actually matter.'
    },
    {
      image: '../../../assets/prod-feature-configuration.svg',
      title: 'Custom AI Instructions for Question Generation',
      intro: 'You decide how the AI should think. Go beyond generic questions - instruct the AI exactly how to generate them.',
      groups: [
        { label: 'Define custom instructions like:', items: ['Tone (industry-specific, simple, advanced, real‑world)', 'Complexity & depth', 'Type (conceptual, case‑based, analytical, technical)', 'Role seniority (junior / mid / senior)', 'Include / exclude specific topics', 'Style & format'] }
      ],
      why: 'Every company is unique. Your questions should be too.'
    },
    {
      image: '../../../assets/prod-feature-candidate-experience.svg',
      title: 'Simple, Fast Assessment Builder',
      intro: 'From zero to live test in under 5 minutes. Built for speed. Designed for simplicity.',
      groups: [
        { label: 'Features:', items: ['Drag‑and‑build experience', 'Preview mode', 'One‑click test sharing', 'No technical knowledge needed'] }
      ],
      why: 'HR teams, founders, and hiring managers can create assessments instantly.'
    },
    {
      image: '../../../assets/prod-feature-question-types.svg',
      title: 'Customized Assessments for Any Role',
      intro: 'One platform for every job function. Create assessments that match your hiring needs across departments.',
      groups: [
        { label: 'Choose your:', items: ['Skills', 'Formats', 'Number of questions', 'Your own custom questions', 'Ready‑made role templates'] }
      ],
      why: 'Perfect for startups, SMEs, and fast‑growing teams hiring across multiple roles.'
    },
    {
      image: '../../../assets/prod-feature-configuration.svg',
      title: 'Difficulty Level Control',
      intro: 'Set the right challenge for the right hire. Tune difficulty instantly.',
      groups: [
        { label: 'Difficulty settings:', items: ['Easy', 'Medium', 'Hard', 'Or mix levels within one assessment.'] }
      ],
      why: 'Hire confidently for interns, juniors, experienced talent, or senior roles.'
    },
    {
      image: '../../../assets/prod-feature-configuration.svg',
      title: 'Multiple Variants per Candidate',
      intro: 'Cheating‑proof by design. Every candidate gets a unique version of the test.',
      groups: [
        { label: 'Built‑in advantages:', items: ['Unlimited variants', 'Auto‑randomized questions', 'Reduced answer sharing', 'Ensures fairness & integrity'] }
      ],
      why: 'Skill assessments stay fair, unbiased, and hard to game.'
    },
    {
      image: '../../../assets/prod-feature-analytics.svg',
      title: 'Skills‑First Shortlisting',
      intro: 'Shift from résumé hiring to skill hiring. Evaltrix highlights candidates who perform best.',
      groups: [
        { label: 'Benefits:', items: ['Removes GPA/college bias', 'Reveals hidden talent', 'Pure performance‑based ranking', 'Stronger hiring decisions'] }
      ],
      why: 'You discover real performers who may be overlooked through traditional screening.'
    },
    {
      image: '../../../assets/prod-feature-configuration.svg',
      title: 'Built‑in Cheating Prevention',
      intro: 'Fair assessments, reliable results.',
      groups: [
        { label: 'Includes:', items: ['Timed tests', 'Variant‑based randomization', 'Attempt control', 'Hard‑to‑predict patterns'] }
      ],
      why: 'Your hiring decisions are based on authentic performance.'
    },
    {
      image: '../../../assets/prod-feature-enterprise.svg',
      title: '10x More Affordable than Other Tools',
      intro: 'Powerful hiring without the enterprise pricing.',
      groups: [
        { label: 'Why companies choose Evaltrix:', items: ['No per‑test fees', 'No per‑candidate fees', 'Unlimited usage', 'Saves up to ₹9,00,000 yearly in effort cost'] }
      ],
      why: 'Perfect for startups, SMEs, agencies, and large teams hiring at scale.'
    },
    {
      image: '../../../assets/prod-feature-enterprise.svg',
      title: 'Built for Scale',
      intro: 'From 10 candidates to 10,000 - instant deployment.',
      groups: [
        { label: 'Scaling benefits:', items: ['Unlimited assessments', 'Unlimited candidates', 'Multi‑role hiring', 'Ideal for bulk hiring & campus drives'] }
      ],
      why: 'Grow your hiring without increasing workload.'
    }
  ];

  constructor(private route: ActivatedRoute) { }

  ngOnInit() { }

  ngAfterViewInit(): void {
    this.route.fragment.subscribe((frag) => {
      if (frag) {
        setTimeout(() => {
          const el = document.getElementById(frag);
          el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 0);
      }
    });
  }

}
